import { useQuery } from '@tanstack/react-query'
import { g100ConsoleApi } from '@/api/endpoints'
import { queryKeys, queryOptions } from '@/config/queryConfig'
import { useAuthStore } from '@/store/authStore'

// #309 — the G100 cameras this user may test. Where the console is off the API answers 404,
// and the sidebar entry and the page are hidden.
export function useG100ConsoleCameras() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  return useQuery({
    queryKey: queryKeys.g100Console.cameras(),
    queryFn: () => g100ConsoleApi.cameras(),
    enabled: isAuthenticated,
    ...queryOptions.g100Console.cameras,
  })
}

export function isConsoleOff(error: unknown): boolean {
  return (error as { response?: { status?: number } } | null)?.response?.status === 404
}
